<template>
  <div id="topic-mapping">
    <!-- begin page-header -->
    <div v-for="(group, index) in groups" v-bind:key="index">
      <h1 class="page-header">{{group.name}}</h1>
      <div class="row">
        <div class="col-md-4 col-sm-12" v-for="(grade, gradeIndex) in group.grades" v-bind:key="gradeIndex">
          <div class="widget widget-stats" v-bind:class="bgColor(grade)">
            <div class="stats-icon"></div>
            <div class="stats-info">
              <h4>{{grade.jenjang.nama}}</h4>
              <p>{{grade.display_name}}</p>
            </div>
            <div class="stats-link">
              <router-link v-if="grade.jenjang.nama !== 'SMA'" :to="{path: '/topic-mapping/detail', query: { interest: 'DEFAULT', grade_id: grade.id}}">Lihat Detail <i class="fa fa-arrow-circle-o-right"></i></router-link>
              <a href="#" v-else @click="mappingDetail(grade)">Lihat Detail <i class="fa fa-arrow-circle-o-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-modal v-if="showModal" :cancelOnly="true" v-on:cancel="showModal = false">
      <h4 slot="header">Pilih Peminatan</h4>
      <div slot="body" style="text-align: center">
        <router-link class="btn btn-lg btn-inverse" :to="{path: '/topic-mapping/detail', query: { interest: 'SAINTEK', grade_id: selectedGrade.id}}">
          <i class="fa fa-flask fa-2x pull-left"></i>
          {{selectedGrade.display_name}}<br />
          <small>IPA</small>
        </router-link>
        <router-link class="btn btn-lg btn-inverse" :to="{path: '/topic-mapping/detail', query: { interest: 'SOSHUM', grade_id: selectedGrade.id}}">
          <i class="fa fa-child fa-2x pull-left"></i>
          {{selectedGrade.display_name}}<br />
          <small>IPS</small>
        </router-link>
      </div>
    </app-modal>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import ItembankService from '@/services/itembank.js'
import Modal from '@/components/plugins/Modal'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'topic-mapping',
  data: function () {
    return {
      groups: [],
      showModal: false,
      isLoading: false,
      selectedGrade: null
    }
  },
  components: {
    'app-modal': Modal,
    'app-spinner': Spinner
  },
  methods: {
    getPicture: function (grade) {
      if (grade.jenjang.nama === 'SD') return '@/static/assets/images/grade_sd.png'
      else if (grade.jenjang.nama === 'SMP') return '@/static/assets/images/grade_smp.png'
      else if (grade.jenjang.nama === 'SMA') return '@/static/assets/images/grade_sma.png'

      return '@/static/assets/images/grade_sma.png'
    },
    bgColor: function (grade) {
      if (grade.jenjang.nama === 'SD') return 'bg-red'
      else if (grade.jenjang.nama === 'SMP') return 'bg-blue'
      else if (grade.jenjang.nama === 'SMA') return 'bg-grey'

      return 'bg-grey'
    },
    mappingDetail: function (grade) {
      this.selectedGrade = grade
      if (grade.jenjang.nama === 'SMA') this.showModal = true
    }
  },
  mounted: function () {
    var context = this
    var groups = []
    this.isLoading = true
    ItembankService.getListOfTopicGrade(function (response) {
      if (response.success) {
        var groups = []
        response.data.forEach(function (data) {
          var groupName = data.jenjang.nama
          var index = groups.findIndex(function (group) {
            return group.name === groupName
          })

          if (index < 0) {
            var group = {
              name: groupName,
              grades: [data]
            }

            groups.push(group)
          } else {
            groups[index].grades.push(data)
          }
        })

        context.groups = groups
        context.isLoading = false
        context.$ls.set('grades', response.data)
      }
    })
  }
}
</script>




// WEBPACK FOOTER //
// TopicMapping.vue?1b50c13e